// Lista de aulas do curso Estratégia, agrupada por módulo (usada no início e no fim da sessão).
// Mesmo visual e mesmas marcas do edital: concluída, em andamento e pendente.
import { useState } from "react";
import { useTheme } from "../lib/theme";
import { estrKey } from "../lib/estrategia";

// Peças compartilhadas das listas de escolha (assuntos do edital e aulas): animação de abrir/fechar e caixa de seleção.
const KF = `@keyframes g17pop{0%{transform:scale(.55);opacity:0}60%{transform:scale(1.18)}100%{transform:scale(1);opacity:1}}
@keyframes g17fade{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}
@media (prefers-reduced-motion: reduce){.g17-pick *{transition:none!important;animation:none!important}}`;
export function PickStyles() { return <style>{KF}</style>; }
export function Collapse({ open, children }) {
  return (
    <div style={{ display:"grid", gridTemplateRows: open ? "1fr" : "0fr", visibility: open ? "visible" : "hidden",
      transition: `grid-template-rows 0.28s cubic-bezier(.4,0,.2,1), visibility 0s linear ${open ? "0s" : "0.28s"}` }}>
      <div style={{ overflow:"hidden", minHeight:0, opacity: open ? 1 : 0, transition:"opacity 0.22s ease" }}>{children}</div>
    </div>
  );
}
export function CheckBox({ state, multi = true }) {   // state: "on" | "off" | "partial"
  const t = useTheme();
  const on = state === "on" || state === "partial";
  const fg = t.mode === "dark" ? "#0a0f0b" : "#fff";
  return multi
    ? <span style={{ width:20, height:20, borderRadius:6, border:`2px solid ${on ? t.ac : t.textFaint}`, background: on ? t.ac : "transparent", display:"flex", alignItems:"center", justifyContent:"center", color:fg, transition:"background 0.18s, border-color 0.18s", flexShrink:0 }}>
        {state === "on" && <svg key="on" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" style={{ animation:"g17pop 0.22s ease-out" }}><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>}
        {state === "partial" && <svg key="p" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" style={{ animation:"g17pop 0.22s ease-out" }}><path d="M6 12h12" /></svg>}
      </span>
    : <span style={{ width:20, height:20, borderRadius:"50%", border:`2px solid ${on ? t.ac : t.textFaint}`, display:"flex", alignItems:"center", justifyContent:"center", transition:"border-color 0.18s", flexShrink:0 }}>
        {on && <span style={{ width:10, height:10, borderRadius:"50%", background:t.ac, animation:"g17pop 0.22s ease-out" }} />}
      </span>;
}

export function EstrAulaList({ course, data, multi, selected, onToggle, onToggleMany, planned, maxHeight = 320 }) {
  const t = useTheme();
  const done = (data && data.course && data.course.done) || {};
  const prog = (data && data.course && data.course.prog) || {};
  const st = id => done[estrKey(course.slug, id)] ? "done" : prog[estrKey(course.slug, id)] ? "doing" : "todo";
  const isSel = id => multi ? !!selected[id] : selected === id;
  const plannedIds = Array.isArray(planned) ? planned : planned ? [planned] : [];
  // Abre o módulo da aula escolhida (ou o primeiro com aula pendente); os outros começam fechados
  const [open, setOpen] = useState(() => {
    const target = (multi ? Object.keys(selected || {})[0] : selected) || plannedIds[0];
    const m = (target && course.mods.find(x => x.aulas.some(a => a.id === target))) || course.mods.find(x => x.aulas.some(a => st(a.id) !== "done")) || course.mods[0];
    return m ? { [m.n]: true } : {};
  });
  const Dot = ({ s }) => s === "done"
    ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={t.ac} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-label="Assistida"><circle cx="12" cy="12" r="9" /><path d="M8 12.5l2.8 2.8L16.5 9.5" /></svg>
    : s === "doing"
      ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={t.ac} strokeWidth="2" strokeDasharray="3 3" aria-label="Em andamento"><circle cx="12" cy="12" r="9" /></svg>
      : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={t.textFaint} strokeWidth="1.6" aria-label="Pendente"><circle cx="12" cy="12" r="9" /></svg>;
  return (
    <div className="g17-pick" style={{ border:`1px solid ${t.border}`, borderRadius:12, overflow:"hidden", maxHeight, overflowY:"auto", WebkitOverflowScrolling:"touch" }}>
      <PickStyles />
      {course.mods.map(m => {
        const isOpen = !!open[m.n];
        const nDone = m.aulas.filter(a => st(a.id) === "done").length;
        const allSel = multi && m.aulas.every(a => isSel(a.id));
        return (
          <div key={m.n}>
            <div style={{ display:"flex", alignItems:"stretch", background:t.bgInner, borderTop:`1px solid ${t.borderIn}` }}>
              <button onClick={() => setOpen(o => ({ ...o, [m.n]: !o[m.n] }))} aria-expanded={isOpen}
                style={{ flex:1, minWidth:0, display:"flex", alignItems:"center", gap:"0.6rem", textAlign:"left", cursor:"pointer", border:"none", background:"transparent", color:t.text, padding:"0.7rem 0.8rem" }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={t.textDim} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
                  style={{ flexShrink:0, transform: isOpen ? "rotate(90deg)" : "none", transition:"transform 0.25s cubic-bezier(.4,0,.2,1)" }}><path d="M9 5l7 7-7 7" /></svg>
                <span style={{ flex:1, minWidth:0, fontSize:"0.84rem", fontWeight:700, lineHeight:1.4 }}>{m.n}. {m.t}</span>
                <span style={{ fontSize:"0.7rem", color: nDone === m.aulas.length ? t.ac : t.textDim, fontWeight:700, flexShrink:0 }}>{nDone}/{m.aulas.length}</span>
              </button>
              {multi && onToggleMany && (
                <button onClick={() => onToggleMany(m.aulas.map(a => a.id), !allSel)} title={allSel ? "Desmarcar todas deste módulo" : "Marcar todas deste módulo"}
                  style={{ flexShrink:0, border:"none", background:"transparent", color:t.ac, cursor:"pointer", fontSize:"0.68rem", fontWeight:800, padding:"0 0.8rem" }}>{allSel ? "Limpar" : "Todas"}</button>
              )}
            </div>
            <Collapse open={isOpen}>{m.aulas.map(a => {
              const on = isSel(a.id), s = st(a.id);
              return (
                <button key={a.id} onClick={() => onToggle(a.id)} role={multi ? "checkbox" : "radio"} aria-checked={on}
                  style={{ width:"100%", display:"flex", alignItems:"flex-start", gap:"0.7rem", textAlign:"left", cursor:"pointer", border:"none", borderTop:`1px solid ${t.borderIn}`,
                    padding:"0.6rem 0.8rem 0.6rem 1.9rem", background: on ? t.acDim : "transparent", color:t.text, transition:"background 0.18s" }}>
                  <span style={{ paddingTop:1, flexShrink:0 }}><CheckBox multi={multi} state={on ? "on" : "off"} /></span>
                  <span style={{ flex:1, minWidth:0, fontSize:"0.82rem", lineHeight:1.45, color: s === "done" && !on ? t.textDim : t.text }}>{a.id} {a.t}</span>
                  <span style={{ display:"flex", alignItems:"center", gap:"0.4rem", flexShrink:0 }}>
                    {plannedIds.includes(a.id) && <span style={{ fontSize:"0.62rem", fontWeight:800, letterSpacing:"0.06em", color:t.ac }}>PLANEJADA</span>}
                    <Dot s={s} />
                  </span>
                </button>
              );
            })}</Collapse>
          </div>
        );
      })}
    </div>
  );
}
